import { Box } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { Line } from 'react-chartjs-2'
import moment from 'moment'
import { useTranslation } from 'react-i18next' // LAP-733 (GE022)

export default function LineChart({ linedata }) {
  const [labels, setLabels] = useState([])
  const [ldata, setLdata] = useState([])
  const { t } = useTranslation('layout') // LAP-733 (GE022)

  useEffect(() => {
    let lab = []
    let dat = []
    if (linedata) {
      linedata.forEach((e) => {
        lab.push(moment(e.Year, 'YYYY-MM-DD').year())
        dat.push(e.Montant)
      })
      setLabels(['', ...lab, ''])
      setLdata([null, ...dat, null])
    }
  }, [linedata])

  const data = {
    labels,
    datasets: [
      {
        label: 'K EUR',
        data: ldata,
        borderColor: '#0dcaf0',
        backgroundColor: '#0dcaf0',
      },
    ],
  }

  const options = {
    maintainAspectRatio: false,
    aspectRatio: 1,
    responsive: true,
    plugins: {
      datalabels: {
        color: 'white',
        align: 'top',
      },
      legend: {
        display: false,
        position: 'top',
      },
      title: {
        display: false,
        text: '',
      },
    },
    scales: {
      x: {
        ticks: {
          display: true,
        },
        offset: true,
        gridLines: {
          display: false,
        },
      },

      y: {
        ticks: {
          display: true,
        },
        display: false,
        gridLines: {
          display: false,
        },
        min: 0,
        max: Math.max(...ldata) * 1.2,
      },
    },
  }

  return (
    <Box
      height={250}
      width={'100%'}
      sx={{
        bgcolor: 'rgba(255,255,255,0.07)',
        border: '1px solid rgba(255,255,255,0.1)',
        borderRadius: 2,
        p: 2,
      }}
    >
      <Box sx={{ color: '#fff', fontWeight: 850, fontSize: 15 }}>{t('finance.monBudget.shortEvolution')}</Box>
      <Box sx={{ color: 'rgba(255,255,255,0.55)', fontSize: 12, mb: 1 }}>
        {t('finance.monBudget.shortEvolutionSubtitle')}
      </Box>
      <Line options={options} data={data} />
    </Box>
  )
}
